var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNumerationFile || _vm.isExternal,
              expression: "isNumerationFile || isExternal"
            }
          ],
          staticClass: "col-md-6"
        },
        [
          _c("list-subject-types", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "subjectType",
            staticClass: "w-100",
            attrs: {
              autocomplete: "",
              label: "Destinos",
              name: "subjectType",
              "data-cy": "subject-type",
              danger: _vm.errors.has(_vm.scope + ".subjectType"),
              "danger-text": _vm.errors.first(_vm.scope + ".subjectType")
            },
            model: {
              value: _vm.subjectForm.subjectType,
              callback: function($$v) {
                _vm.$set(_vm.subjectForm, "subjectType", $$v)
              },
              expression: "subjectForm.subjectType"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNumerationFile || _vm.isExternal,
              expression: "isNumerationFile || isExternal"
            }
          ],
          staticClass: "col-md-6"
        },
        [
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType === "oficinas"
            ? _c("list-offices", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType === "oficinas"
                    },
                    expression:
                      "{ required:  !isInput.includes(subjectForm.subjectType)\n              && subjectForm.subjectType === 'oficinas' }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Oficina",
                  name: "subject",
                  "data-cy": "subject",
                  danger: _vm.errors.has(_vm.scope + ".subject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType === "unidades"
            ? _c("list-groups", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType === "unidades"
                    },
                    expression:
                      "{ required:  !isInput.includes(subjectForm.subjectType)\n              && subjectForm.subjectType === 'unidades' }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Unidad",
                  name: "subject",
                  "data-cy": "subject",
                  typeList: 1,
                  danger: _vm.errors.has(_vm.scope + ".subject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType !== "usuarios" &&
          _vm.subjectForm.subjectType !== "oficinas" &&
          _vm.subjectForm.subjectType !== "unidades" &&
          _vm.subjectForm.subjectType !== "sanitarias"
            ? _c("list-subjects", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType !== "usuarios" &&
                        _vm.subjectForm.subjectType !== "oficinas" &&
                        _vm.subjectForm.subjectType !== "unidades" &&
                        _vm.subjectForm.subjectType !== "sanitarias"
                    },
                    expression:
                      "{\n           required: !isInput.includes(subjectForm.subjectType)\n              && subjectForm.subjectType !== 'usuarios'\n              && subjectForm.subjectType !== 'oficinas'\n              && subjectForm.subjectType !== 'unidades'\n              && subjectForm.subjectType !== 'sanitarias'\n          }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Lista de Destino",
                  name: "subject",
                  "data-cy": "subject",
                  "parent-value": _vm.subjectForm.subjectType,
                  disabled: !_vm.subjectForm.subjectType,
                  danger: _vm.errors.has(_vm.scope + ".subject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
          _vm.subjectForm.subjectType === "usuarios"
            ? _c("list-user", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required:
                        !_vm.isInput.includes(_vm.subjectForm.subjectType) &&
                        _vm.subjectForm.subjectType === "usuarios"
                    },
                    expression:
                      "{\n            required: !isInput.includes(subjectForm.subjectType)\n              && subjectForm.subjectType === 'usuarios'\n          }"
                  }
                ],
                key: "subject-select",
                ref: "subject",
                staticClass: "w-100",
                attrs: {
                  "with-filters": "",
                  withFilters: "",
                  rolId: "7441a75e-80b9-486a-8595-34c487a56dd9",
                  autocomplete: "",
                  label: "Lista de Destino",
                  name: "subject",
                  "data-cy": "subject",
                  disabled: !_vm.subjectForm.subjectType,
                  danger: _vm.errors.has(_vm.scope + ".subject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e(),
          _vm.isInput.includes(_vm.subjectForm.subjectType)
            ? _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.isInput.includes(
                        _vm.subjectForm.subjectType
                      )
                    },
                    expression:
                      "{ required: isInput.includes(subjectForm.subjectType) }"
                  }
                ],
                key: "subject-input",
                staticClass: "w-100",
                attrs: {
                  label: "Ingrese un nombre",
                  name: "subject",
                  "data-cy": "subject",
                  danger: _vm.errors.has(_vm.scope + ".subject"),
                  "danger-text": _vm.errors.first(_vm.scope + ".subject")
                },
                model: {
                  value: _vm.subjectForm.subject,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subject", $$v)
                  },
                  expression: "subjectForm.subject"
                }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm.subjectForm.subjectType === "docDigital"
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("list-institutions-doc-digital", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.subjectForm.subjectType === "docDigital"
                    },
                    expression:
                      "{ required: subjectForm.subjectType === 'docDigital'}"
                  }
                ],
                ref: "subjectTypeDigitalDoc",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Lista de Instituciones DocDigital",
                  name: "subjectTypeDigitalDoc",
                  "data-cy": "subject-type-digital-doc",
                  "parent-value": _vm.subjectForm.subject,
                  danger: _vm.errors.has(_vm.scope + ".subjectTypeDigitalDoc"),
                  "danger-text": _vm.errors.first(
                    _vm.scope + ".subjectTypeDigitalDoc"
                  )
                },
                model: {
                  value: _vm.subjectForm.subjectTypeDigitalDoc,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subjectTypeDigitalDoc", $$v)
                  },
                  expression: "subjectForm.subjectTypeDigitalDoc"
                }
              })
            ],
            1
          ),
          _vm.subjectForm.subjectType === "docDigital" &&
          _vm.subjectForm.subject !== "" &&
          _vm.subjectForm.subject !== undefined
            ? _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c(
                    "vs-checkbox",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value:
                            "Seleccionar todas las instituciones DocDigital",
                          expression:
                            "'Seleccionar todas las instituciones DocDigital'"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: {
                        color: "primary",
                        disabled: _vm.disabledSelectAll
                      },
                      nativeOn: {
                        change: function($event) {
                          return _vm.selectDocDigital()
                        }
                      },
                      model: {
                        value: _vm.selectAllDocDigital,
                        callback: function($$v) {
                          _vm.selectAllDocDigital = $$v
                        },
                        expression: "selectAllDocDigital"
                      }
                    },
                    [_vm._v(" Seleccionar todas ")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm.emailRequired.includes(_vm.subjectForm.subjectType)
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.emailRequired.includes(
                        _vm.subjectForm.subjectType
                      ),
                      email: true
                    },
                    expression:
                      "{\n            required: emailRequired.includes(subjectForm.subjectType)\n            ,\n            email: true\n          }"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Correo Electrónico Persona Destinatario",
                  name: "subjectEmail",
                  "data-cy": "subject-email",
                  danger: _vm.errors.has(_vm.scope + ".subjectEmail"),
                  "danger-text": _vm.errors.first(_vm.scope + ".subjectEmail")
                },
                model: {
                  value: _vm.subjectForm.subjectEmail,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "subjectEmail", $$v)
                  },
                  expression: "subjectForm.subjectEmail"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.subjectForm.subjectType === "usuarios"
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "vs-select",
                {
                  staticClass: "w-100 con-select autocompletex",
                  attrs: {
                    autocomplete: "",
                    label: "Seleccione tipo de providencia",
                    name: "providence",
                    "data-cy": "providence"
                  },
                  model: {
                    value: _vm.subjectForm.providence,
                    callback: function($$v) {
                      _vm.$set(_vm.subjectForm, "providence", $$v)
                    },
                    expression: "subjectForm.providence"
                  }
                },
                [
                  !_vm.isExternal
                    ? _c("vs-select-item", {
                        attrs: {
                          value: _vm.providenceTypes.KNOWLEDGE,
                          text: "Conocimiento"
                        }
                      })
                    : _vm._e(),
                  _c("vs-select-item", {
                    attrs: {
                      value: _vm.providenceTypes.MANAGEMENT,
                      text: "Para gestión"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("label", [_vm._v("Fecha Vencimiento")]),
              _c("b-form-datepicker", {
                attrs: {
                  locale: "es",
                  min: _vm.minDate,
                  placeholder: "Fecha vencimiento",
                  name: "providenceExpiration",
                  "label-help": "Puede usar las flechas del teclado y espacio"
                },
                model: {
                  value: _vm.subjectForm.providenceExpiration,
                  callback: function($$v) {
                    _vm.$set(_vm.subjectForm, "providenceExpiration", $$v)
                  },
                  expression: "subjectForm.providenceExpiration"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-12 d-flex align-items-end justify-content-end" },
        [
          _vm.error.message !== ""
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
                  staticStyle: { height: "32px" }
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.error.message) + " ")
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "col-12 d-flex align-items-end justify-content-end" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: { "data-cy": "add-recipient-button", variant: "primary" },
              on: {
                click: function($event) {
                  return _vm.addSubject()
                }
              }
            },
            [_vm._v(" Agregar Destinatario ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }